import { useMemo } from "react"
import { useHabitacionesForReportQuery, useMesasForReportQuery } from "src/gql/schema"
import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { useProfile } from "src/shared/hooks/useProfile"
import { HeaderProps } from "../../hooks/useHeaderProps"

const isValid = (value?: string | null): value is string =>
    value !== null && value !== undefined && value !== ""

const useOrigenHeader = <T extends string>({ headerValue, valueToDisplay }: HeaderProps<T>) => {
    const { hotel_id } = useProfile()

    const { data: habitacionesData } = useHabitacionesForReportQuery({ variables: { hotel_id } })
    const { data: mesasData } = useMesasForReportQuery({ variables: { hotel_id } })

    const habitaciones = useMemo(
        () => habitacionesData?.habitaciones.map((h) => h.numero_habitacion).filter(isValid) || [],
        [habitacionesData]
    )

    const mesas = useMemo(
        () => mesasData?.mesas.map((m) => m.numero_mesa).filter(isValid) || [],
        [mesasData]
    )

    const header = useMemo<FlexibleTableHeaderColumn>(
        () => ({
            value: headerValue,
            valueToDisplay,
            filterMenu: [
                ...habitaciones.map((v) => ({ value: v, valueToDisplay: v })),
                ...mesas.map((v) => ({ value: v, valueToDisplay: v })),
                {
                    value: "mostrador",
                    valueToDisplay: "Mostrador",
                },
            ],
            filterSuggetions: true,
        }),
        [headerValue, valueToDisplay, habitaciones, mesas]
    )

    return { header, habitaciones, mesas }
}

export default useOrigenHeader
